import { Typography } from '@material-ui/core'
import { Alert, AlertTitle } from '@material-ui/lab'
import { chain } from 'lodash'
import React, { useContext, useState, useMemo, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import ControlContainer from '../components/ControlContainer'
import ValueGapIndicator from '../components/ValueGapIndicator'
import { OrderContext } from '../OrderContext'
import { CancelButton, FakeNextButton, NextButton, PreviousButton } from '../StepperButtons'
import { ExchangeItemContextProvider } from './ExchangeItemContext'
import ExchangeList from './ExchangeList'
import ItemSearch from './ItemSearch'
import {useIsSmall} from "../components/MediaHelpers";

const AddItems = () => {
    const { order, purchases, simulate, loadingSimulate, customer } = useContext(OrderContext)
    const [displayError, setDisplayError] = useState(false)
    const { t } = useTranslation()
    const isSmall = useIsSmall()

    // Always recalculate amounts on every render using useMemo
    const { returnAmount, exchangeAmount } = useMemo(() => {
        // Always use local order for returnAmount
        const returnAmount = chain(order).reduce((acc, mb) => acc + ((mb.quantity || 0) * parseFloat(mb.price)), 0).value();
        // Always use local purchases for validation
        const exchangeAmount = purchases.reduce((acc, p) => acc + (parseFloat(p.materialPrice || '0') * (p.quantity || 0)), 0);
        return { returnAmount, exchangeAmount };
    }, [order, purchases]);

    // Ensure validation and UI update immediately after purchases change
    useEffect(() => {
        // This will force a re-render and validation after every purchases change
        // If error is showing and the new state is valid, hide the error
        const returnCents = Math.round(returnAmount * 100);
        const exchangeCents = Math.round(exchangeAmount * 100);
        if (displayError && returnCents <= exchangeCents) {
            setDisplayError(false);
        }
    }, [purchases, returnAmount, exchangeAmount, displayError]);

    if (!simulate && loadingSimulate) {
        return <p>{t('loading_order_data')}...</p>
    }
    
    const returnCents = Math.round(returnAmount * 100);
    const exchangeCents = Math.round(exchangeAmount * 100);
    const disabled = returnCents > exchangeCents;
    const fakeDisabled = purchases.length === 0

    return (
        <ExchangeItemContextProvider>
            <ItemSearch />

            {purchases.length > 0 && (
                <ValueGapIndicator 
                    returnAmount={returnAmount} 
                    exchangeAmount={exchangeAmount} 
                    currency={customer?.currency || 'EUR'} 
                />
            )}

            {!isSmall && <Typography variant='h5' style={{ marginBottom: 45 }}>{t('you_are_returning')}:</Typography>}

            <ExchangeList />

            {
                displayError && disabled &&
                <Alert severity="error" style={{ marginTop: 30, marginBottom: 30 }}>
                    <AlertTitle>{t('error_equivilent_or_more')}</AlertTitle>
                </Alert>
            }

            <ControlContainer>
                {disabled ? <FakeNextButton onClick={() => setDisplayError(true)} disabled={fakeDisabled} /> : <NextButton disabled={disabled} />}
                <PreviousButton />
                <CancelButton />
            </ControlContainer>
        </ExchangeItemContextProvider>
    )
}

export default AddItems
